<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      {{$t('leaderInformation')}}
    </template>
    <div class="scroll_wrap">
      <vue-scroll v-show="!loading">
        <div class="info_item">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="">
            {{$t('basicInformation')}}
          </div>
          <div class="base_info">
            <div class="col">
              <span>{{$t('name')}}：{{leaderInfo.idName}}</span>
              <span>{{$t('gender')}}：{{leaderInfo.gender}}</span>
            </div>
            <div class="col">
              <span>{{$t('phone')}}：{{leaderInfo.phone}}</span>
              <span>{{$t('birthPlace')}}：{{'--'}}</span>
            </div>
            <div class="col">
              <span>{{$t('idNumber')}}：{{leaderInfo.idNumber}}</span>
              <span>{{$t('status')}}：{{leaderInfo.userStatus | filterUserStatus}}</span>
            </div>
          </div>
        </div>
        <div class="info_item">
          <div class="info_title between">
            <div class="flex_box">
              <img src="@/assets/images/common/player_squad.png" alt="">
              {{$t('bindingTeam')}}
            </div>
          </div>
          <div class="score_wrap">
            <div
              v-for="(item, index) in squadList"
              :key="index"
              class="score_item"
              @click="goSquad">
              <div class="header">{{item.shortName}}</div>
              <div class="content">
                <img :src="item.banner" alt="" @error="item.banner = squadImg">
                <div class="score_info">
                  <p><span>{{$t('leader')}}：{{item.leaderName}}</span></p>
                  <p><span>{{$t('executiveCoach')}}：{{item.chiefCoachName}}</span><span></span></p>
                  <p><span>{{$t('coachTeams')}}：{{item.coachTeamNum}} {{$t('people')}}</span><span>{{$t('players')}}：{{item.playerTeamNum}} {{$t('people')}}</span></p>
                </div>
              </div>
            </div>
          </div>
          <yioks-empty v-if="squadList.length === 0" :h="'2rem'"></yioks-empty>
        </div>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
    </div>
  </SubContent>
</template>

<script>

import leader from '@/api/leader'
import { filterUserStatus } from '@/utils/yioks_filter'
import squadImg from '@/assets/images/common/squad.png'

export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    filterUserStatus
  },
  data () {
    return {
      leaderUuid: this.$route.query.uuid,
      loading: true,
      squadImg,
      leaderInfo: {},
      squadList: []
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      leader.getLeaderInfo(this.leaderUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
          this.$router.push('/')
        } else {
          this.loading = false
          this.leaderInfo = res.leader
          this.squadList = res.squadList ? res.squadList : []
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    goSquad () {
      this.$router.push({
        path: '/squad/detail',
        query: {
          uuid: this.leaderInfo.squadUuid
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .scroll_wrap
    height 100%
    padding .2rem 0 .1rem .2rem
    box-sizing border-box
    overflow hidden
    .info_item
      margin 0 .3rem .3rem .1rem
      .info_title
        font-size .2rem
        padding .1rem 0 .2rem
        display flex
        align-items center
        img
          margin-right .1rem
          width .26rem
        &.between
          justify-content space-between
          .flex_box
            display flex
            align-items center
          .tutorial
            span
              padding-right .1rem
              padding-left .05rem
              &:last-child
                padding-right .05rem
        .yioks_btn
          padding .06rem .2rem
        .more
          padding-right .1rem
          cursor pointer
      .base_info
        border 1px solid #FFF
        .col
          border-bottom 1px solid
          padding .16rem .3rem
          display flex
          justify-content space-around
          span
            display inline-block
            width 100%
          &:last-child
            border none
      .score_wrap
        display flex
        flex-wrap wrap
        .score_item
          padding-bottom .2rem
          width 3.95rem
          cursor pointer
          &:nth-child(odd)
            margin-right .4rem
          .header
            height .3rem
            background url('~@/assets/images/common/squad_bg.png') no-repeat
            background-size 1.72rem .3rem
            line-height .3rem
            padding-left .15rem
            font-size .18rem
          .content
            border 1px solid #FFF
            padding .2rem .15rem
            display flex
            img
              width .54rem
              height .8rem
              margin-right .1rem
            .score_info
              p
                margin-bottom .1rem
                span
                  margin-right .2rem
                  &:last-child
                    margin 0
      .tutorial_wrap
        display flex
        justify-content space-between
        .item_box
          background rgba(0, 0, 0 ,.35)
          border 2px solid transparent
          padding .2rem
          width 3.6rem
          &:hover
            background rgba(0,0,0,.35) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
            box-shadow inset 0 0 .12rem $green_color
            border 2px solid $green_color
          .flex_box
            display flex
            border-bottom 1px solid #FFF
            padding-bottom .15rem
            img
              margin-right .2rem
              height 1rem
              width 1.7rem
            p
              width 1.45rem
              text-overflow ellipsis
              overflow hidden
              white-space nowrap
          .info
            display flex
            div
              margin-right .2rem
            p
              margin-top .1rem
    .manageSquad_wrap
      .el-row
        margin-bottom 20px
        .el-col
          line-height 40px
          text-align center
      .btn_wrap
        display flex
        justify-content center
        padding-top 20px
</style>
